<div class="main-bg">
    <!-- center aligned copyight text and 3 links-->
    <div class="container">
        <div class="d-flex justify-content-center align-items-center py-3">
            <div class="text-center text-black font-size-14">
                © {{ currentYear | date:'yyyy' }} MCANISM. All rights reserved.
                <a target="_blank" [routerLink]="['/legal/privacy-policy']" class="text-black font-size-14 mx-3">Privacy Policy</a>
                <a target="_blank" [routerLink]="['/legal/imprint']" class="text-black font-size-14 mx-3">Imprint</a>
            </div>
        </div>
    </div>
</div>
